import axios from 'axios';
import { TVSIPriceBoardHasAuth, constHostAddressConfig } from "./constData";
import { getUserFromStorage, removeUserFromStorage } from "../redux/actions/sharedActions";
import store from '../redux/store';

export const getToken = () => {
  const userLocalStorage = getUserFromStorage();
  return userLocalStorage?.token;
};

let isRefreshing = false;
let subscribers = [];
const ignoreUrls = ["HomeMobile/GeneratetOken"];

const client = axios.create({
  baseURL: constHostAddressConfig.ApiTVSIAddress,
  headers: {
    "Content-Type": "application/json",
  },
});

client.interceptors.request.use(async (config) => {
  config.headers["Authorization"] = TVSIPriceBoardHasAuth === "1" ? `Bearer ${getToken()}` : ``;
  config.headers["App-Language"] = localStorage.getItem("6442047A0753470C83107037F72D197B");
  config.headers["Device-Id"] = `name`;
  return config;
});

client.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error.response);

    if (error.response?.status === 500) {
    //   notificationShare(-1, "Kết nối đến server thất bại");
      return Promise.reject(error);
    } else if (error.response?.status === 401) {
      removeUserFromStorage();
      store.dispatch({ type: "ClearUser" });
    } else {

    }

    return Promise.reject(error);
  }
);
window.axiosClient = client;

//
export const useAxios = () => {
  let client = window.axiosClient;
  let clientHelper = {
    get: (url, config) => client.get(url, config),
    getAsync: async (url, config) => await client.get(url, config),
    post: (url, payload, config) => client.post(url, payload, config),
    postAsync: async (url, payload, config) => await client.post(url, payload, config),
    patch: (url, payload, config) => client.patch(url, { ...payload }, config),
    delete: (url, payload, config) => client.delete(url, { data: { ...payload } }, config),
    put: (url, payload, config) => client.put(url, { ...payload }, config),
    postFile: (url, file, config) => client.post(url, file, { ...config, headers: { "Content-Type": undefined } }),
    client: client,
  };
  return clientHelper;
};

export const useShareApi = (controller) => {
  const httpRequest = useAxios();
  return {
    addOne: (jsonData) => {
      return httpRequest.post(``, jsonData);
    },
  };
};

const axiosClient = axios.create({
  baseURL: constHostAddressConfig.ApiTVSIAddress,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getFromApi = (path) => {
  return axiosClient.get(removeDoubleSlashURL(path));
};

export const getFromApiAsync = async (path) => {
  return await axiosClient.get(removeDoubleSlashURL(path));
};

// Utils
const removeDoubleSlashURL = (url) => {
  return url.replace(/([^:]\/)\/+/g, "$1");
};
